!(function () {
  'use strict';
  class t extends window.theme.DeferredMedia {
    constructor() {
      super();
    }
    loadContent() {
      super.loadContent(),
        Shopify.loadFeatures([
          {
            name: 'model-viewer-ui',
            version: '1.0',
            onLoad: this.setupModelViewerUI.bind(this),
          },
        ]);
    }
    setupModelViewerUI(t) {
      t ||
        (this.modelViewerUI = new Shopify.ModelViewerUI(
          this.querySelector('model-viewer')
        ));
    }
  }
  (window.ProductModel = {
    loadShopifyXR() {
      Shopify.loadFeatures([
        {
          name: 'shopify-xr',
          version: '1.0',
          onLoad: this.setupShopifyXR.bind(this),
        },
      ]);
    },
    setupShopifyXR(t) {
      t ||
        (window.ShopifyXR
          ? (document.querySelectorAll('[id^="ModelJSON-"]').forEach((t) => {
              window.ShopifyXR.addModels(JSON.parse(t.textContent)), t.remove();
            }),
            window.ShopifyXR.setupXRElements())
          : document.addEventListener('shopify_xr_initialized', () =>
              this.setupShopifyXR()
            ));
    },
  }),
    window.addEventListener('DOMContentLoaded', () => {
      window.ProductModel && window.ProductModel.loadShopifyXR();
    });

  const e = '[data-add-to-cart]',
    r = '[data-product-json]',
    o = '[data-product-form]',
    i = '#cart-bar',
    s = '[data-popup-open]',
    a = '.product__submit__add',
    n = '[data-form-wrapper]',
    d = '[data-product-variants]',
    c = 'is-loading',
    l = 'is-visible',
    h = 'data-cart-bar-enabled',
    u = 'data-add-to-cart-bar',
    p = 'data-cart-bar-scroll',
    m = 'data-cart-bar-product-notification',
    f = 'data-sticky-enabled';
  customElements.get('') ||
    customElements.define(
      'product-component',
      class extends HTMLElement {
        constructor() {
          super(),
            (this.stickyEnabled = 'true' === this.getAttribute(f)),
            (this.formWrapper = this.querySelector(n)),
            (this.cartBarEnabled = this.hasAttribute(h)),
            (this.cartBar = this.querySelector(i)),
            (this.setCartBarHeight = this.setCartBarHeight.bind(this)),
            (this.scrollToTop = this.scrollToTop.bind(this)),
            (this.toggleCartBarOnScroll =
              this.toggleCartBarOnScroll.bind(this)),
            (this.unlockTimer = 0);
        }
        connectedCallback() {
          const t = this.querySelector(r);
          if ((t && !t.innerHTML) || !t) return;
          const e = JSON.parse(t.innerHTML).handle;
          let i = {};
          e && (i = { handle: e }),
            Shopify.Products.recordRecentlyViewed(i),
            Shopify.Products &&
              Shopify.Products.recordRecentlyViewed &&
              Shopify.Products.recordRecentlyViewed(i),
            (this.form = this.querySelector(o)),
            this.cartBarEnabled &&
              (this.initCartBar(),
              this.setCartBarHeight(),
              document.addEventListener(
                'theme:scroll',
                this.toggleCartBarOnScroll
              ),
              document.addEventListener('theme:resize', this.setCartBarHeight));
        }
        initCartBar() {
          (this.cartBarBtns = this.cartBar.querySelectorAll(a)),
            this.cartBarBtns.length > 0 &&
              this.cartBarBtns.forEach((t) => {
                t.addEventListener('click', (t) => {
                  t.preventDefault(),
                    t.currentTarget.hasAttribute(u)
                      ? (this.cartBarEnabled &&
                          (t.currentTarget.classList.add(c),
                          t.currentTarget.setAttribute('disabled', 'disabled')),
                        this.form
                          .querySelector(e)
                          .dispatchEvent(new Event('click', { bubbles: !0 })))
                      : t.currentTarget.hasAttribute(p)
                      ? this.scrollToTop()
                      : t.currentTarget.hasAttribute(m) &&
                        this.form
                          .querySelector(s)
                          ?.dispatchEvent(new Event('click'));
                }),
                  t.hasAttribute(u) &&
                    document.addEventListener(
                      'theme:product:add-error',
                      this.scrollToTop
                    );
              }),
            this.setCartBarHeight();
        }
        scrollToTop() {
          const t = this.querySelector(d),
            e = (
              window.theme.isMobile() ? t || this.form : this
            ).getBoundingClientRect().top;
          window.theme.scrollTo(window.theme.isMobile() ? e - 10 : e);
        }
        toggleCartBarOnScroll() {
          const t = window.scrollY,
            e =
              theme.variables.productPageSticky && this.formWrapper
                ? this.formWrapper
                : this.form;
          if (e && this.cartBar) {
            const r = t > e.offsetTop + e.offsetHeight;
            this.cartBar.classList.toggle(l, r);
          }
        }
        setCartBarHeight() {
          const t = this.cartBar.offsetHeight;
          document.documentElement.style.setProperty(
            '--cart-bar-height',
            `${t}px`
          );
        }
        disconnectedCallback() {
          document.removeEventListener(
            'theme:product:add-error',
            this.scrollToTop
          ),
            this.cartBarEnabled &&
              (document.removeEventListener(
                'theme:scroll',
                this.toggleCartBarOnScroll
              ),
              document.removeEventListener(
                'theme:resize',
                this.setCartBarHeight
              ));
        }
      }
    ),
    customElements.get('product-model') ||
      customElements.define('product-model', t);
})();

///////////////////
// 右カラム遅延表示
///////////////////
const productContent = document.querySelector('.product__content');

setTimeout(() => {
  productContent.style.opacity = 1;
}, 100);

///////////////////
// zoom処理
///////////////////
document.addEventListener('DOMContentLoaded', () => {
  /* ---------- 対象スライドを安全に取得 ---------- */
  const slideEls = Array.from(
    document.querySelectorAll('.product__slide')
  ).filter((slide) => slide.querySelector('img'));

  if (!slideEls.length) return;

  /* ---------- DOM 参照 ---------- */
  const overlay = document.querySelector('.custom-zoom-overlay');
  const inner = overlay.querySelector('.zoom-scroll-inner');
  const closeBtn = overlay.querySelector('.zoom-close');

  /* ---------- Lenis への参照を 1 回だけ保持 ---------- */
  // const lenis = window?.lenis; // テーマに無ければ undefined

  /* ---------- スライドクリックでズーム ---------- */
  slideEls.forEach((slide, idx) => {
    slide.style.cursor = 'zoom-in';

    slide.addEventListener('click', () => {
      // lenis?.stop?.(); // 背景の Lenis 停止
      inner.innerHTML = '';

      /* ---------- 画像を追加しつつ <img> ノードを配列で保持 ---------- */
      const imgNodes = slideEls.map((slide) => {
        const origin = slide.querySelector('img');
        const z = document.createElement('img');

        // ① 最低限の src は currentSrc で OK
        z.src = origin.currentSrc || origin.src;

        // ② srcset / sizes をコピー
        z.srcset = origin.getAttribute('srcset') || '';
        z.sizes = '100vw'; // ズーム画面では常に全幅想定

        inner.appendChild(z);
        return z;
      });

      /* ---------- オーバーレイ表示 ---------- */
      overlay.style.display = 'flex';
      document.body.style.overflow = 'hidden';

      /* ---------- スクロール実行を「クリック位置までの画像」が全て読めた後に遅延実行 ---------- */
      const waitList = imgNodes.slice(0, idx + 1); // 先頭〜クリック画像まで
      let remain = waitList.length;

      function tryScroll() {
        if (--remain === 0) {
          // すべてロード完了 → 位置が確定
          const target = imgNodes[idx];
          inner.scrollTo({ top: target.offsetTop, behavior: 'instant' });
        }
      }

      /* すでに読み込み済みの <img> は naturalWidth が 0 でない */
      waitList.forEach((img) => {
        if (img.complete && img.naturalWidth) {
          tryScroll();
        } else {
          img.addEventListener('load', tryScroll, { once: true });
        }
      });
    });
  });

  /* ---------- 閉じるボタン & 画像クリック ---------- */
  closeBtn.addEventListener('click', closeZoom);
  inner.addEventListener('click', (e) => {
    if (e.target.tagName === 'IMG') closeZoom();
  });

  /* ---------- 閉じる共通処理 ---------- */
  function closeZoom() {
    overlay.style.display = 'none';
    document.body.style.overflow = '';
    // lenis?.start?.(); // v1.1〜
    // lenis?.resume?.(); // v1.0 系
  }
});

///////////////////
// ギャラリー制御（遷移時）
// 必ず1枚目の画像を表示する
///////////////////
(() => {
  const run = () => {
    // すでに戻したなら何もしない（リロード/履歴復元対策）
    if (sessionStorage.getItem('bc_media_reset_done') === '1') return;

    // productページ判定（必要なら条件調整OK）
    const isProduct =
      document.body.className.includes('template-product') ||
      document.querySelector('[data-section-type="product"]') ||
      document.querySelector('.product');

    if (!isProduct) return;

    // 1) まずサムネ（1枚目）をクリックできるならクリック（テーマ依存に強い）
    const firstThumb = document.querySelector(
      '[data-product-single-thumbnail]:first-child, [data-thumbnail-id]:first-child, .product__thumbs a:first-child, .product__thumbs button:first-child, .product__thumbs-item:first-child a, .product__thumbs-item:first-child button'
    );

    if (firstThumb) {
      firstThumb.click();
    } else {
      // 2) クリックできなければ、ギャラリーを先頭へスクロール（フェイルセーフ）
      const track = document.querySelector(
        '.product__photos, .product__media, .product__gallery, [data-product-photos], [data-product-media]'
      );

      if (track) {
        track.scrollTo({ left: 0, top: 0, behavior: 'auto' });
      }
    }

    sessionStorage.setItem('bc_media_reset_done', '1');
  };

  // DOM準備後に実行（Broadcastは初期化が少し遅いことがあるので軽く遅延）
  document.addEventListener('DOMContentLoaded', () => {
    run();
  });

  // テーマがPJAX/Historyで遷移する場合の保険
  window.addEventListener('pageshow', () => {
    setTimeout(run, 50);
  });

  // ※ productページを離れたらフラグを戻す（次の「商品詳細遷移」でまた1枚目に戻すため）
  // ここがポイント：商品詳細へ「遷移したときは常に」戻したいので、離脱で解除します。
  window.addEventListener('pagehide', () => {
    sessionStorage.removeItem('bc_media_reset_done');
  });
})();
